import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { classNames } from "src/helpers/classNames";
import Button from "src/components/Shared/Buttons/Button";

const Accordion = ({ children, headerContent, startOpen = false, isCollapsible = true, isSelected = false }) => {
  const [show, setShow] = useState(startOpen);

  return (
    <div className={classNames("relative w-full cursor-pointer rounded-xl border-2 shadow-sm transition-all duration-200", isSelected ? "border-green-500 bg-green-50" : show ? "border-gray-200 bg-white" : "border-gray-100 bg-white hover:border-gray-200")}>
      <div className={classNames("flex items-center gap-4 rounded-t-xl px-4 py-3 transition-all duration-200", show ? "rounded-t-xl" : "rounded-xl")}>
        {isCollapsible ? (
          <Button
            type="button"
            version="default"
            onClick={(e) => {
              e.stopPropagation();
              setShow(!show);
            }}
            className="flex h-8 w-8 items-center justify-center rounded-md border-0 bg-transparent px-1 py-1 text-gray-700 shadow-none outline-none ring-0 ring-transparent hover:bg-gray-100">
            <ChevronDownIcon
              className={classNames("h-4 w-4 stroke-2 transition-all duration-200", show ? "" : "-rotate-90")}
              aria-hidden="true"
            />
          </Button>
        ) : (
          <div className="h-8 w-8"></div>
        )}

        {headerContent()}
      </div>

      <div className={classNames("relative overflow-hidden transition-all duration-300 ease-in-out", show ? "max-h-[999999px] pb-4" : "max-h-0")}>
        <div className="px-4">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
